let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("860dT")).then(() => parcelRequire('8KFPL'));